import QuestionFilter from 'components/modules/QuestionFilter/QuestionFilter';
import QuestionDetails from 'components/modules/QuestionDetails/QuestionDetails';
import QuestionPreview from 'components/modules/QuestionPreview/QuestionPreview';
import SolutionPreview from 'components/modules/SolutionPreview/SolutionPreview';

import { Link } from "react-router-dom";
const QuestionPage = (props: any) => (
    <>
      {/* <QuestionFilter/> */}
      <QuestionDetails />
      <QuestionPreview />
      <SolutionPreview />
      <div className='row'>
        <div className='col-md-12'>
          
        </div>
      </div>
  </>
);

export default QuestionPage;
